import React from 'react';
import {useState, useEffect, createContext, useContext, useCallback} from "react";

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';

function Select_Combination(props){

    const{
        CombinationID,
        CombinationOptions,
        CombinationID_Callback,
    } = props;

    function onChange_CombinationID(P_CombinationID){
        CombinationID_Callback(P_CombinationID);
    }

    return(
        <Grid item xs={3}>
            <FormControl style={{ width: '100%' }}>
                <InputLabel id="CombinationLabel">Combination</InputLabel>
                <Select native='true' value={CombinationID} name="Combination" id="Combination" labelId="CombinationLabel" onChange={e => onChange_CombinationID(e.target.value)}>
                    {CombinationOptions}
                </Select>
            </FormControl>
        </Grid>
    )

}

export{
    Select_Combination,
};